if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        let preorder = false;
        evt.submitter.classList.forEach(c => {
          if(c == 'preorder') {
            preorder = true;
          }
        });
        evt.preventDefault();
        if(preorder) {
          const display =
            '<div style="text-align: left">'+
                '<h2>How Do Pre-Orders Work?</h2>' +
                '<ul>' +
                    '<li>Pre-Order this Box and it will ship on the manufacturer release date.</li>' +
                    '<li>Manufacturer release dates are subject to change.</li>'+
                    '<li>If you pre-order multiple items with different release dates, your items will not ship until the last item has released.</li>'+
                    '<li>If you need to cancel/refund your pre-order. you will be subject to a 20% cancellation fee. Which will be excluded in the refund process.' +
                '</ul>'+
                '<h2>What is the Collector Store LLC Pre-Order Guarantee?</h2>' +
                '<p>Buy with confidence! If you pre-order with us, whether the market goes up or down, we guarantee that all pre-orders will be fulfilled.<strong>*</strong></p>' +
                '<input type="checkbox" id="swal-input1" class="swal2-input"><label>I understand that I am subject to the 20% cancellation fee if I decide to cancel this pre-order.</label><br>' +
                '<input type="checkbox" id="swal-input2" class="swal2-input"><label>I understand that my items will not ship until the last item has released.</label>'+
            '</div>';
          const { value: accept } = await Swal.fire({
            html: display,
            preConfirm: function() {
              return new Promise(function (resolve) {
                // Validate input
                if (!document.getElementById('swal-input1').checked || !document.getElementById('swal-input2').checked) {
                    swal.showValidationMessage("Check that you understand the above conditions order to continue."); // Show error when validation fails.
                    swal.enableButtons(); // Enable the confirm button again.
                } else {
                    swal.resetValidationMessage(); // Reset the validation message.
                    resolve([
                      document.getElementById('swal-input1').value,
                      document.getElementById('swal-input2').value
                    ]);
                }
              }).then(function(result) {
                return true;
              }).catch(swal.noop);
            },
            showCancelButton: true,
            reverseButtons: true,
            footer: '<strong>*</strong> In the very rare occurrence that there is a production issue and a manufacturer is forced ' +
            'to cut production numbers we will do our best to work with the customer to find the best possible solution. ' +
            'However, there may be certain instances beyond our control where we are unable to come to a solution.',
            confirmButtonText: 'Continue',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'button',
              cancelButton: 'button button--secondary'
            },
          });
          if (accept) {
            this.processAdd();
          }
        } else {
          this.processAdd();
        }
      }

      processAdd() {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
